import React from 'react';

import { useDispatch } from 'react-redux';

import Column from '@amzn/meridian/column';
import Row from '@amzn/meridian/row';
import SearchField from '@amzn/meridian/search-field';
import Select, { SelectOption } from '@amzn/meridian/select';
import Tab, { TabGroup } from '@amzn/meridian/tab';
import Toggle from '@amzn/meridian/toggle';
import useIsT2Experience from 'src/hooks/useIsT2Experience';
import { setT2Mode } from 'src/store/newJmrPageSlice/newJmrPageSlice';
import { useAppSelector } from 'src/store/store';
import { isT2Admin, JmrJobTypes } from 'src/utils/jmrUtils';

interface TopOptionsProps {
  isLoading?: boolean;
  searchField?: string;
  setSearchField?: (val: string) => void;
  scrollToJob?: (jobId: string) => void;
  handleTabChange: (jobType: JmrJobTypes) => void;
}
const TopOptions = ({ isLoading, searchField, setSearchField, scrollToJob, handleTabChange }: TopOptionsProps) => {
  const dispatch = useDispatch();
  const { jmrFilter, backgroundFormData, t2AdminToggle, jmrResults } = useAppSelector((state) => state.newJmrPage);
  const { featureFlags, ldap } = useAppSelector((state) => state.user);

  const selectedOptions = jmrResults.filter((r) => r.isChecked);
  const isUsingT2Experience = useIsT2Experience();

  const getT2OverrideToggleDisplayState = () => {
    if (t2AdminToggle !== null) {
      return t2AdminToggle;
    }
    return +(backgroundFormData?.jobLevel || '') > 1;
  };

  return (
    <Column width="100%" spacing="none">
      <Row spacingInset="400 none none none" backgroundColor="white">
        {!isUsingT2Experience && (
          <TabGroup value={jmrFilter.jobType} onChange={handleTabChange}>
            <Tab value={JmrJobTypes.ProcessPath} aria-label="Process Path" data-cy="new-jmr__results__process-path-btn">
              Process Path
            </Tab>
            <Tab value={JmrJobTypes.TLD} aria-label="TLD" data-cy="new-jmr__results__tld-btn">
              TLD
            </Tab>
          </TabGroup>
        )}
      </Row>

      <Row
        width="100%"
        widths={!isUsingT2Experience ? ['fill', 'fit', 'fit'] : ['fit']}
        alignmentHorizontal={isUsingT2Experience ? 'end' : 'justify'}
        spacingInset="400 none"
        alignmentVertical="center"
        backgroundColor="white"
      >
        {!isUsingT2Experience && (
          <Row>
            {!!setSearchField && (
              <SearchField
                value={searchField}
                aria-label="Search"
                onChange={setSearchField}
                placeholder="Search for..."
                onSubmit={() => {}}
              />
            )}

            {scrollToJob && (
              <Select
                disabled={!selectedOptions.length}
                placeholder={`${selectedOptions.length || 'None'} Selected`}
                onChange={(id: string) => scrollToJob(id)}
              >
                {selectedOptions.map((row) => (
                  <SelectOption label={row.name} value={row.id} key={row.id} />
                ))}
              </Select>
            )}
          </Row>
        )}

        {isT2Admin(ldap) && featureFlags.T2_PLUS_EXPERIENCE ? (
          <Toggle
            disabled={isLoading ?? false}
            checked={getT2OverrideToggleDisplayState()}
            onChange={() => dispatch(setT2Mode(!getT2OverrideToggleDisplayState()))}
            aria-label="T2+ Experience Toggle"
          >
            T2+ Experience
          </Toggle>
        ) : null}
      </Row>
    </Column>
  );
};

export default TopOptions;
